import { Directive, ElementRef, HostListener, Input, OnChanges, OnInit, Optional, Self, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';
import { PhoneValidatorService } from 'src/app/core/services/phone-validator.service';

@Directive({
    selector: '[phoneNumberMask]',
    standalone: false
})
export class PhoneNumberMaskDirective implements OnInit, OnChanges {
  @Input() countryCodeISO2: string = ''; // Input for country code
  private maskPattern: string = ''; // Placeholder for mask pattern

  constructor(
    private el: ElementRef,
    @Optional() @Self() private control: NgControl,
    private phoneValidator: PhoneValidatorService, // Inject your phone validator service
  ) {}

  ngOnInit(): void {
    this.setMaskPattern();
    if (this.control && this.control.valueChanges) {
      this.control.valueChanges.subscribe((value) => {
        this.applyMask(value);
      });
    }

    // Apply mask to the initial value
    this.applyMask(this.el.nativeElement.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryCodeISO2']) {
      this.setMaskPattern();
      this.applyMask(this.el.nativeElement.value); // Reapply mask with new country code
    }
  }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    this.applyMask(input.value);
  }

  private setMaskPattern(): void {
    if (this.countryCodeISO2) {
      this.maskPattern = this.phoneValidator.getPhoneNumberPlaceholder(this.countryCodeISO2);
    }
  }

  private applyMask(value: string): void {
    if (!value || !this.maskPattern) return;

    let cleaned = value.replace(/\D/g, '');
    const parts = this.maskPattern.split(' ');
    let formattedValue = '';
    let index = 0;

    for (const part of parts) {
      const partLength = part.replace(/\D/g, '').length;
      if (index < cleaned.length) {
        formattedValue += cleaned.substr(index, partLength) + ' ';
        index += partLength;
      } else {
        break;
      }
    }

    this.el.nativeElement.value = formattedValue.trim();

    // If using a form control, update the form control value as well
    if (this.control && this.control.control) {
      this.control.control.setValue(this.el.nativeElement.value, { emitEvent: false });
    }
  }
}
